var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMspLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.68082 4.89999H7.06285L7.34757 4.64528C8.49546 3.61835 10.1686 3 12 3C13.8314 3 15.5045 3.61835 16.6524 4.64528L16.9372 4.89999H17.3192H18.422C18.7438 4.89999 19.0541 5.03783 19.2699 5.27655C19.485 5.51448 19.59 5.83577 19.5569 6.15516C19.5569 6.15517 19.5569 6.15519 19.5569 6.15521L18.1762 19.4718L18.1215 19.9999H5.87755L5.82284 19.4719L4.44319 6.15506C4.44317 6.15491 4.44316 6.15477 4.44314 6.15462C4.41032 5.83426 4.51507 5.514 4.72911 5.27663C4.94622 5.03702 5.256 4.89999 5.57796 4.89999H6.68082Z",
    stroke: "#02B27F",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 6H11V9H8V11H11V16H13V11H16V9H13V6Z",
    fill: "#F2AE00"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMspLight);
export default __webpack_public_path__ + "static/media/mspLight.cbe7e562af0f55380f3830207b2b66bd.svg";
export { ForwardRef as ReactComponent };